import { useQuery } from "@tanstack/react-query";
import { brandService } from "../api/services/brandService";

const OPTIONS_PAGE_SIZE = 200;

/**
 * Brands as dropdown options, for assigning creatives on the tenant side.
 * There is no dedicated dropdown resolver for brands — the list is small
 * enough that one page covers it.
 */
export const useBrandOptions = (options?: { enabled?: boolean }) => {
  const {
    data,
    isLoading: isBrandOptionsLoading,
    refetch: refetchBrandOptions,
  } = useQuery({
    queryKey: ["brandOptions"],
    queryFn: () => brandService.getAll({ page: 1, pageSize: OPTIONS_PAGE_SIZE }),
    enabled: options?.enabled !== false,
  });

  const brandOptions = (data?.brands ?? []).map((brand) => ({
    value: brand.id,
    label: brand.name,
  }));

  return {
    brandOptions,
    isBrandOptionsLoading,
    refetchBrandOptions,
    hasMoreThanOnePage: (data?.total ?? 0) > OPTIONS_PAGE_SIZE,
  };
};
